module.exports = __webpack_public_path__ + "static/media/callhost.cc6eb172.svg";